<template>
    <div 
        class="banner-buttons"
        :class="bannerButtonClasses"
    >
        <v-btn
            rounded
            large
            dark
            :color="buttonColor"
            :class="vButtonFirstItemClass"
            :style="{ color: buttonColor === '#FFFFFF' || buttonColor === '#8BC5EB' ? '#001426' : '#FFFFFF' }"
            @click="goToSelectedBlueprint"
        >
            {{ buttonTitle }}
        </v-btn>

        <v-btn
            v-show="!isLoggedIn"
            rounded
            outlined
            large
            color="#FFFFFF"
            :class="vButtonSecondItemClass"
            @click="goToAccountLogin"
        >
            Login to my account
        </v-btn>
    </div>
</template>

<script>
    import { EventBus } from "../../../utils/eventBus";
    export default {
        name: "BannerButtons",
        props: {
            buttonTitle: {
                default: 'Learn More',
                type: String,
            },
            buttonColor: {
                default: '#424EC4',
                type: String,
            },
            vButtonFirstItemClass: {
                default: '',
                type: String,
            },
            vButtonSecondItemClass: {
                default: '',
                type: String,
            },
            bannerButtonClasses: String,
        },
        data(){
            return {
            }
        },
        methods: {
            goToSelectedBlueprint() {
                this.$emit('goToBlueprintItem');
            },
            goToAccountLogin(){
                this.$router.push("login");
                EventBus.$emit("activate-indicated-menu-item", "Sign In/Register");
            },
        },
        computed: {
            isLoggedIn() {
                console.log(this.$store.state.isLoggedIn);
			    return this.$store.state.isLoggedIn;
		    },
        },
    }
</script>

<style scoped>
.banner-buttons .v-btn.banner-buttons-xl-lg-md {
  font-size: clamp(6px, 1vw, 14px) !important;
}
.banner-buttons .v-btn:last-child {
  margin-left: 10px;
}
</style>